/** Shared easing — smooth deceleration */
export const easeOut = [0.22, 1, 0.36, 1];

export const transitionBase = {
  duration: 0.5,
  ease: easeOut,
};

export const transitionSnappy = {
  duration: 0.38,
  ease: easeOut,
};

/** Re-triggers when block leaves view (scroll in / scroll out) */
export const scrollViewport = {
  once: false,
  amount: 0.22,
  margin: '0px 0px -32px 0px',
};

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: {
    opacity: 1,
    y: 0,
    transition: transitionBase,
  },
};

export const fadeUpTight = {
  hidden: { opacity: 0, y: 18 },
  visible: {
    opacity: 1,
    y: 0,
    transition: transitionSnappy,
  },
};

export const fadeSlideRight = {
  hidden: { opacity: 0, x: 40 },
  visible: {
    opacity: 1,
    x: 0,
    transition: transitionBase,
  },
};

export const fadeSlideLeft = {
  hidden: { opacity: 0, x: -36 },
  visible: {
    opacity: 1,
    x: 0,
    transition: transitionBase,
  },
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.94 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: transitionBase,
  },
};

export const heroStagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.09,
      delayChildren: 0.08,
    },
  },
};

export const heroItem = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: transitionSnappy,
  },
};

export const cardStagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.11,
      delayChildren: 0.05,
    },
  },
};
